var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
		background: _vm.color,
		left: _vm.left + 'px',
		top: _vm.top,
		bottom: _vm.bottom,
		right: _vm.right,
		position: 'fixed',
		overflow: 'auto'
	})},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }